import React from 'react';

import PropTypes from 'prop-types';

import Spinner from '@/components/common/Spinner';
import CheckImage from '@/images/icons/check-circle.svg';
import ExclamationImage from '@/images/icons/exclamation-circle.svg';

const Icon = ({ type, className }) => {
  switch (type) {
    case 'loading':
      return <Spinner className={className} />;
    case 'error':
      return <img src={ExclamationImage} alt="Erro" className={className} />;
    default:
      return <img src={CheckImage} alt="Sucesso" className={className} />;
  }
};

Icon.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
};

Icon.defaultProps = {
  type: null,
  className: '',
};

export default Icon;
